<template>
  <div class="sidebar bg-danger">
    <div class="sidebar-wrapper">
      <div class="logo" to="/overview">
      <router-link :to="{path:'/overview'}">
        <span class="simple-text logo__container">
          <div class="logo-img m-0">
              <img to="/overview" src="~@/assets/logo.jpeg" class="w-100" alt="logo">
          </div>
          {{title}}
        </span>
      </router-link>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :to="link.path"
                        @click="closeNavbar"
                        :link="link">
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
  import SidebarLink from './SidebarLink.vue'

  export default {
    components: {
      SidebarLink
    },
    props: {
      title: {
        type: String,
        default: 'COMFORT LIKVIDAČNÍ',
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose
      }
    }
  }

</script>
<style>
  .sidebar .sidebar-wrapper {
    display: flex;
    flex-direction: column;
   }
  .sidebar .nav-main__links {
    flex: 1;
  }
  .sidebar .sidebar-wrapper .logo .logo__container {
    padding-left: 10px;
  }

  .router-link-active a {
    color: white;
    opacity: 1;
    background: rgba(255,255,255,0.23);
  }
</style>
